export default "__VITE_ASSET__ffdf9aa9__"